import { FormulaVariable } from './../salary-modifier/salary-modifier.model';
import { MessageDTO } from './../shared/model/message.model';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SalaryModifier, SalaryModifierSearch, ModifierVariable } from '../salary-modifier/salary-modifier.model';
import { SchoolService } from './school.service';
import { logRequest } from 'app/main/shared/http-utils';

@Injectable({
    providedIn: 'root',
})
export class SalaryModifierService {
    baseUrl = '/school-service/api/modifier';

    constructor(
        private http: HttpClient,
        private schoolService: SchoolService
    ) {}

    getAll(): Observable<SalaryModifier[]> {
        const schoolId = this.schoolService.getActiveSchool().id;
        return this.http.get<SalaryModifier[]>(`${this.baseUrl}/school/${schoolId}`);
    }

    getById(id: string): Observable<HttpResponse<SalaryModifier>> {
        return this.http.get<SalaryModifier>(`${this.baseUrl}/${id}`, {
            observe: 'response',
        });
    }

    delete(id: string): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${id}`, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    create(dto: SalaryModifier): Observable<HttpResponse<SalaryModifier>> {
        dto.school = { id: this.schoolService.getActiveSchool().id };
        return this.http.post<SalaryModifier>(this.baseUrl, dto, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    update(dto: SalaryModifier): Observable<HttpResponse<SalaryModifier>> {
        dto.school = { id: this.schoolService.getActiveSchool().id };
        return this.http.put<SalaryModifier>(this.baseUrl, dto, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    search(search: SalaryModifierSearch): Observable<HttpResponse<SalaryModifier[]>> {
        const schoolId = this.schoolService.getActiveSchool().id;
        search.schoolId = schoolId;
        return this.http.post<SalaryModifier[]>(`${this.baseUrl}/search`, search, {
            observe: 'response',
        });
    }

    testFormula(formula: string, variables: ModifierVariable[]): Observable<HttpResponse<MessageDTO>> {
        const formulaVariable: FormulaVariable = new FormulaVariable();
        formulaVariable.formula = formula;
        formulaVariable.variables = variables;
        formulaVariable.schoolId = this.schoolService.getActiveSchool().id;
        return this.http.post<MessageDTO>(`${this.baseUrl}/formula-test`, formulaVariable, {
            observe: 'response',
        });
    }

    getFormulaVariables(schoolId: string): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/school/${schoolId}/variables`);
    }
}
